export interface HeroTopPulseAnchor {
  readonly xPercent: number
  readonly yPercent: number
  readonly plusDuration: number
  readonly plusDelay: number
  readonly ringDuration: number
  readonly ringDelay: number
  readonly plusSize: number
}

/** Hand-placed anchors across the hero top band — deterministic, not random at runtime. */
export const HERO_TOP_PULSE_ANCHORS: readonly HeroTopPulseAnchor[] = [
  { xPercent: 14, yPercent: 16, plusDuration: 4.8, plusDelay: 0, ringDuration: 6.2, ringDelay: 0.2, plusSize: 10 },
  { xPercent: 31, yPercent: 24, plusDuration: 5.6, plusDelay: 1.4, ringDuration: 7.1, ringDelay: 0.8, plusSize: 11 },
  { xPercent: 52, yPercent: 10, plusDuration: 4.2, plusDelay: 0.6, ringDuration: 5.8, ringDelay: 1.6, plusSize: 12 },
  { xPercent: 71, yPercent: 18, plusDuration: 6.1, plusDelay: 2.2, ringDuration: 6.8, ringDelay: 0.4, plusSize: 10 },
  { xPercent: 86, yPercent: 12, plusDuration: 5.2, plusDelay: 1.8, ringDuration: 7.4, ringDelay: 2.4, plusSize: 9 },
  { xPercent: 42, yPercent: 28, plusDuration: 4.6, plusDelay: 3.1, ringDuration: 6.5, ringDelay: 1.2, plusSize: 10 },
  { xPercent: 63, yPercent: 30, plusDuration: 5.9, plusDelay: 2.6, ringDuration: 5.5, ringDelay: 3.0, plusSize: 11 },
]

export const HERO_TOP_PULSE_RING_COUNT = 2
